const hamburger = document.querySelector("#hamburger");
const closeHamburger = document.querySelector("#hamburger-close");
const mobileMenu = document.querySelector("#mobile-menu");
const faqSubSections = document.querySelectorAll("ul#faq-section > li")
let isMenuOpen = false;


function resetStylesAndHideContent() {
  faqSubSections.forEach(section => {
    section.style.backgroundColor = 'transparent'; // Reset background color
    section.style.color = ''; // Reset text color

    // Hide all content sections
    const contentId = section.getAttribute('data-content');
    const contentElement = document.getElementById(contentId);
    if (contentElement) {
      contentElement.style.display = 'none';
    }
  });
}
function toggleAccordion(button) {
  const content = button.nextElementSibling;
  const svgIcon = button.querySelector('svg');

  if (content.classList.contains('max-h-0')) {
    // Expand the content
    content.classList.remove('max-h-0');
    content.classList.add('max-h-40'); // Adjust max-height based on content size
    svgIcon.classList.add('rotate-180');
  } else {
    // Collapse the content
    content.classList.add('max-h-0');
    content.classList.remove('max-h-40');
    svgIcon.classList.remove('rotate-180');
  }
}

// Add click event listener to each FAQ subsection
faqSubSections.forEach(section => {
  section.addEventListener('click', function() {
    // Reset styles and hide content
    resetStylesAndHideContent();

    // Set active styles for the clicked section
    this.style.backgroundColor = '#282725'; // Set the background color
    this.style.color = 'white'; // Set the text color

    // Show the content corresponding to the clicked section
    const contentId = this.getAttribute('data-content');
    const contentElement = document.getElementById(contentId);
    if (contentElement) {
      contentElement.style.display = 'block';
    }
  });
});

hamburger.addEventListener("click", () => {
  isMenuOpen = true;
  mobileMenu.style.transform = "translateX(0%)";
  document.documentElement.classList.add("no-scroll");
  document.body.classList.add("no-scroll");
});

closeHamburger.addEventListener("click", () => {
  isMenuOpen = false;
  mobileMenu.style.transform = "translateX(-100%)";
  document.documentElement.classList.remove("no-scroll");
  document.body.classList.remove("no-scroll");
});

function playHeroVideo() {
  const video = document.querySelector("#video_hero");
  if (!video) return;

  if (video.paused) {
    video.play();
  }
}

document.addEventListener("touch", playHeroVideo)

document.addEventListener("DOMContentLoaded", function () {
  const links = document.querySelectorAll("nav a"); // Select all nav links
  const currentPath = window.location.pathname; // Get the current path

  playHeroVideo()
  
  links.forEach((link) => {
    if (link.getAttribute("href") === currentPath) {
      link.classList.add("active__nav-link");
    }
  });
});
